module.exports = __webpack_public_path__ + "img/VEGblanc.18c235ec.png";